<!--eslint-disable-->
<template>
    <div class="current-year">
        <div class="head">
            <div class="time" @click="showPicker = true">
                <span>{{ currentYear }}</span>
                <i class="iconfont iconxiala"></i>
            </div>
            <div class="statisticalData">
                <div>
                    <h3>{{ totalOutputStatistics.filled_volume }}</h3>
                    <p>生产方量(方)</p>
                </div>
                <div>
                    <h3>{{ totalOutputStatistics.sale_volume }}</h3>
                    <p>发货方量(方)</p>
                </div>
            </div>
            <van-popup
                v-model="showPicker"
                position="bottom"
            >
                <van-picker
                    show-toolbar
                    :columns="yearData"
                    :default-index="currentYearIndex"
                    @cancel="showPicker = false"
                    @confirm="onConfirm"
                ></van-picker>
            </van-popup>
        </div>
        <div class="split"></div>
        <div class="tableLest" v-if="productionStatistics.length>0">
            <div class="title">
                <span class="van_right">
                    单位：(方)
                </span>
            </div>
            <div class="table-left">
                <table>
                    <thead>
                    <tr>
                        <th colspan="2"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="(row,i) in productionStatistics[0].detailsDatas">
                        <tr :key="'row'+i">
                            <th rowspan="2">
                                {{ row.strength_grade_name }}
                            </th>
                            <th><div class="cell">产量</div></th>
                        </tr>
                        <tr>
                            <th>占比</th>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="table-right">
                <table>
                    <thead>
                    <tr>
                        <th v-for="(item,index) in productionStatistics" :key="'name'+index">
                            <div class="thead-cell">{{ item.enterprise_name }}</div>
                        </th>
                    </tr>
                    </thead>
                    <template>
                        <tbody>
                        <template v-for="(row,i) in productionStatistics[0].detailsDatas">
                            <tr :key="'row'+i">
                                <td v-for="(item,k) in productionStatistics" :key="'cl'+k">
                                    {{ item.detailsDatas[i].filled_volume }}
                                </td>
                            </tr>
                            <tr>
                                <td v-for="(item,z) in productionStatistics" :key="'zb'+z">
                                    {{ item.detailsDatas[i].rate }}%
                                </td>
                            </tr>
                        </template>
                        </tbody>
                    </template>
                </table>
            </div>

        </div>
        <div class="empty-data" v-if="!productionStatistics.length>0">
            暂无数据
        </div>
    </div>
</template>

<script>
export default {
    name: 'current-year',
    components: {},
    data() {
        return {
            // 年数据集
            yearData: [],
            // 当前年
            currentYear: '',
            // 当前年下标
            currentYearIndex: 0,
            // 选择年弹出层状态
            showPicker: false,
            // 总产量统计数据
            totalOutputStatistics: {
                filled_volume: 0,
                sale_volume: 0,
            },
            // 场站数据
            stationData: [],
            // 产量统计数据
            productionStatistics: [],
        };
    },
    props: {
        filterData: Object,
    },
    watch: {
        filterData() {
            this.getProductionStatistics();
        },
    },
    computed: {},
    created() {
        this.currentYear = new Date().getFullYear();
        // 添加年数据
        this.addYearData();
        // 获取产量统计数据
        this.getProductionStatistics();
    },
    mounted() {},
    methods: {
        // 确认年
        onConfirm(val) {
            this.showPicker = false;
            this.currentYear = val;

            // 获取产量统计数据
            this.getProductionStatistics();
        },
        // 添加年数据
        addYearData() {
            const startingYear = 1990;
            for (let i = 0; i < 51; i++) {
                const newYear = startingYear + i;
                if (newYear === this.currentYear) {
                    this.currentYearIndex = i;
                }
                this.yearData.push(newYear + ' 年');
            }
        },
        // 时间格式处理
        formatDate() {
            const date = new Date();
            const y = date.getFullYear();
            return y;
        },
        // 获取产量统计数据
        async getProductionStatistics() {
            const year = (this.currentYear + '').replace(' 年', '');
            await this.$axios
                .post('/interfaceApi/report/production/productiondata/year/' + year, this.filterData)
                .then(res => {
                    this.totalOutputStatistics.filled_volume = res.filled_volume.toFixed(2);
                    this.totalOutputStatistics.sale_volume = res.sale_volume.toFixed(2);

                    this.productionStatistics = res.detailsDatas;
                })
                .catch(error => {
                    this.$toast.fail(error.ErrorCode.Message);
                });
        },
        // 处理数据
        processingData(data) {
            const newData = [];
            data.forEach(item => {
                newData.push(item.enterprise_name);
            });
            return newData;
        },
    },
};
</script>

<style scoped lang="stylus">
.current-year
    .empty-data{
        font-size 28rpx
        line-height 200rpx
        text-align center
        color #ccc
    }
    .head
        padding 15rpx
        .time
            height 40rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 0.2)
            text-align center
            line-height 38rpx
            font-size 14rpx
        .statisticalData
            display flex
            height 100rpx
            display flex
            padding-top 14rpx
            >div
                flex 1
                text-align center
                margin 0 4rpx
                padding 15rpx 0
                &:nth-of-type(1)
                    background rgba(85, 136, 241, 0.06)
                    margin-left 0
                    h3
                        color #5588F1
                &:nth-of-type(2)
                    background rgba(250, 132, 54, 0.06)
                    h3
                        color #FA8436
            h3
                font-size 16rpx
                line-height 30rpx
            p
                font-size 12rpx
                line-height 20rpx
                color #979EA7
    .split
        background #F0F0F0
        height 15rpx
        padding 0
    .tableLest
        padding 15rpx
        overflow auto
        .table-left
            width 30%;
            float left
        .table-right
            width 70%;
            float left
            overflow-x auto;
        .title
            height 16rpx
            overflow hidden
            margin-bottom 8rpx
            h4
                font-size 16rpx
                line-height 16rpx
                color #333333
            span
                font-size 12rpx
                height 16rpx
                line-height 16rpx
                color #979EA7
        table
            width 100%
            th,td
                font-size 16rpx;
                font-weight 400
                height 35rpx
                text-align center
                white-space nowrap
                .thead-cell
                    min-width 80rpx;
                .cell
                    min-width 50rpx;
            thead
                th
                    background #DEE3EF
                    border 1px solid #EBF0FC
                    color #333333
            tbody
                &:nth-of-type(odd)
                    th
                        background #DEE3EF
                        border 1px solid #EBF0FC
                        color #333333
                    td
                        background rgba(85, 136, 241, 0.04)
                        color #5588F1
                &:nth-of-type(even)
                    th
                        background #F5F2ED
                        border 1px solid #EFE4D3
                        color #823802
                    td
                        background rgba(250, 132, 54, 0.04)
                        color #FA8436
</style>
